// extracted by mini-css-extract-plugin
module.exports = {"root":"_2bcPD1gOTfEOpDjLwEKP4p","content":"_1OTVvwMUdb4VRSvJ_h-qP1"};